import { cn } from "@/lib/utils";

/** Valor ausente, sempre do mesmo jeito. Hífen por padrão (sem travessão na UI). */
export function EmptyValue({ label = "-", className }: { label?: string; className?: string }) {
  return <span className={cn("text-muted-foreground", className)}>{label}</span>;
}
